import React, { useState } from 'react';
import {
    Typography,
    Box,
    Alert,
    FormGroup,
    FormControlLabel,
    Switch,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Send } from '@mui/icons-material';

import { useAppDispatch, useAppSelector } from 'hooks';
import { sendUpdateEmailPreference } from 'state/auth';

interface Props {}

const UpdatePasswordForm: React.FunctionComponent<Props> = ({}) => {
    const dispatch = useAppDispatch();

    const { tokens, user: usrObj } = useAppSelector((root) => root.auth);

    const user = usrObj.object;

    const [allowEmails, setAllowEmails] = useState(user?.profile.allowEmails);

    const [sending, setSending] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    const isValid = allowEmails != null && tokens.object?.accessToken != null;

    const sendUpdatePasswordRequest = async () => {
        if (allowEmails == null) return;

        setSending(true);
        setError('');
        setMessage('');

        try {
            const results = await dispatch(
                sendUpdateEmailPreference({
                    allowEmails,
                }),
            );

            if (results.error) setError(results.error);

            if (results.success) setMessage('Command sent successfully');
        } finally {
            setSending(false);
        }
    };

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1,
                gridTemplateRows: 'auto auto 1fr auto',
            }}
        >
            <Typography variant="h6">Email Alerts</Typography>
            {error && (
                <Alert severity="error" onClose={() => setError('')}>
                    {error}
                </Alert>
            )}
            {message && (
                <Alert severity="success" onClose={() => setMessage('')}>
                    {message}
                </Alert>
            )}

            <Typography variant="body1">Modify Email Preferences</Typography>
            {/* Section for Command Parameters */}
            <Box sx={{ display: 'grid', gap: 1 }}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={allowEmails}
                                onChange={(_e, checked) =>
                                    setAllowEmails(checked)
                                }
                            />
                        }
                        label="Allow Recieving Email Alerts"
                    />
                </FormGroup>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <LoadingButton
                    variant="contained"
                    onClick={sendUpdatePasswordRequest}
                    loading={sending}
                    disabled={!isValid}
                    endIcon={<Send />}
                >
                    Submit
                </LoadingButton>
            </Box>
        </Box>
    );
};

UpdatePasswordForm.displayName = 'UpdatePasswordForm';
export default UpdatePasswordForm;
